import Footer from "components/navigation/Footer";
import Navbar from "components/navigation/Navbar";
import Layout from "hocs/layouts/Layout";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import CategoriesHeader from "components/blog/CategoriesHeader";
import { useParams } from "react-router-dom";
import BlogList from "components/blog/BlogList";
import { fetchBlogListByCategory, fetchCategories } from "utils/apiContent";

function Category() {
	const params = useParams();
	const slug = params.slug;
	const [categories, setCategories] = useState(null);
	const [posts, setPosts] = useState(null);
	const [count, setCount] = useState(0);
	const [, setNext] = useState(null);
	const [, setPrevious] = useState(null);

	const get_blog_list_category_page = async (page) => {
		try {
			const data = await fetchBlogListByCategory(slug, page);
			setPosts(data.items);
			setCount(data.count);
			setNext(data.next);
			setPrevious(data.previous);
		} catch (error) {
			setPosts([]);
			setCount(0);
			setNext(null);
			setPrevious(null);
		}
	};

	useEffect(() => {
		let mounted = true;
		window.scrollTo(0, 0);
		const load = async () => {
			try {
				const [categoriesData, blogData] = await Promise.all([
					fetchCategories(),
					fetchBlogListByCategory(slug),
				]);
				if (!mounted) return;
				setCategories(categoriesData);
				setPosts(blogData.items);
				setCount(blogData.count);
				setNext(blogData.next);
				setPrevious(blogData.previous);
			} catch (error) {
				if (!mounted) return;
				setCategories([]);
				setPosts([]);
				setCount(0);
				setNext(null);
				setPrevious(null);
			}
		};
		load();

		return () => {
			mounted = false;
		};
	}, [slug]);

	return (
		<Layout>
			<Helmet>
				<title>Corpoindustrial| Categoría: {slug}</title>
				<meta
					name="description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta
					name="keywords"
					content="empresas, agremiados, norte de santander"
				/>
				<meta name="robots" content="all" />
				<link rel="canonical" href="https://corpoindustrial.co/" />
				<meta name="author" content="Corpoindustrial" />
				<meta name="publisher" content="Corpoindustrial" />

				{/* Social Media Tags */}
				<meta property="og:title" content="Corpoindustrial" />
				<meta
					property="og:description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta property="og:url" content="https://corpoindustrial.co/" />
				<meta
					property="og:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>

				<meta name="twitter:title" content="Corpoindustrial" />
				<meta
					name="twitter:description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta
					name="twitter:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>
			<header className="flex justify-center">
				<Navbar />
			</header>
			<div className="pt-24">
				<CategoriesHeader categories={categories && categories} />
				<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
					{/* We've used 3xl here, but feel free to try other max-widths based on your needs */}
					<div className="mx-auto max-w-6xl my-10">
						{/* Content goes here */}
						<BlogList
							posts={posts && posts}
							get_blog_list_page={get_blog_list_category_page}
							count={count && count}
						/>
					</div>
				</div>
			</div>
			<Footer />
		</Layout>
	);
}
export default Category;
